import {Control, Controller} from 'react-hook-form';
import {InputField} from '../../../../../../../ui/input-field';
import {WorkStagesServiceData, DataType} from '../../../../../../../shared/types/form.types';
import {get} from 'lodash';

interface RenderProps {
  activeStepIndex: number;
  index: number;
  control: Control<WorkStagesServiceData>;
}

const STATIC_PROPS = {
  placeholder: '0',
  maxWidth: '102px',
  InputProps: {
    sx: {
      '& .MuiInputBase-input': {
        textAlign: 'center',
      },
    },
  },
} as const;

const ADDITIONAL_FIELDS_PROPS = {
  fileCount: ({activeStepIndex, index}: RenderProps) => {
    return {
      name: `steps.${activeStepIndex}.fieldGroups.${index}.fileCount`,
      label: 'Кол-во файлов',
    } as const;
  },
  defaultValue: ({activeStepIndex, index}: RenderProps) => {
    return {
      name: `steps.${activeStepIndex}.fieldGroups.${index}.defaultValue`,
      label: 'Знач-е по умолчанию',
    } as const;
  },
  empty: () => null,
} as const;

const RENDERERS = {
  [DataType.String]: ADDITIONAL_FIELDS_PROPS.empty,
  [DataType.Date]: ADDITIONAL_FIELDS_PROPS.empty,
  [DataType.Barcode]: ADDITIONAL_FIELDS_PROPS.empty,
  [DataType.File]: ADDITIONAL_FIELDS_PROPS.fileCount,
  [DataType.Multiple]: ADDITIONAL_FIELDS_PROPS.fileCount,
  [DataType.Number]: ADDITIONAL_FIELDS_PROPS.defaultValue,
} as const;

export const renderAdditionalFields = (fieldType: DataType, props: RenderProps) => {
  const getAdditionalFieldProps = get(RENDERERS, fieldType);
  const additionalProps = getAdditionalFieldProps(props);

  if (!additionalProps) return null;

  const {control} = props;

  return (
    <Controller
      name={additionalProps.name}
      control={control}
      render={({field}) => <InputField label={additionalProps.label} {...STATIC_PROPS} {...field} />}
    />
  );
};
